import card_dispenser from "../../assets/icons/card-dispenser.svg";
import card_encoder from "../../assets/icons/card-encoder.svg";
import cash_acceptor from "../../assets/icons/cash-acceptor.svg";
import aavgo_portal from "../../assets/icons/aavgo-portal.svg";
import agent_network_issue from "../../assets/icons/agent-network-issue.svg";
import audio from "../../assets/icons/audio.svg";
import { default as cash_dispenser, default as cash_dispensed } from "../../assets/icons/cash-dispensed.svg";
import other from "../../assets/icons/other.svg";
import pms_application from "../../assets/icons/pms-application.svg";
import power_outage from "../../assets/icons/power-outage.svg";
import property_network_issues from "../../assets/icons/property-network-issues.svg";
import receipt_printer from "../../assets/icons/receipt-printer.svg";
import registration_card from "../../assets/icons/registration-card.svg";
import { default as id_scanner, default as id_scan} from "../../assets/icons/id-scanned.svg";
import credit_card from "../../assets/icons/credit-card.svg";
import splashtop from "../../assets/icons/splashtop.svg";
import video_call from "../../assets/icons/video-call.svg";
import AcculockIssues from "../../assets/icons/acculock-key-software.svg";
import AssaAbloyIssues from "../../assets/icons/assaabloy-key-software.svg";
import BeelineIssues from "../../assets/icons/beeline-key-software.svg";
import CameraIssues from "../../assets/icons/camera.svg";
import ChoiceAdvantageIssues from "../../assets/icons/choice-advantage-PMS.svg";
import FalsePositiveIssues from "../../assets/icons/false-positive.svg";
import InnGuruIssues from "../../assets/icons/innguru-key-software.svg";
import JCSoftwareIssues from "../../assets/icons/jonas-chorum-PMS-software.svg";
import KioskAppIssues from "../../assets/icons/kiosk-app.svg";
import KioskMachineIssues from "../../assets/icons/kiosk-machine.svg";
import MiwaIssues from "../../assets/icons/miwa-key-software.svg";
import NetWorkIssues from "../../assets/icons/network.svg";
import OtherPMSIssues from "../../assets/icons/other-PMS.svg";
import PBXIssues from "../../assets/icons/PBX.svg";
import SafeLockIssues from "../../assets/icons/safelock-key-software.svg";
import SafLockIssues from "../../assets/icons/saflok-key-software.svg";
import SkyTouchIssues from "../../assets/icons/skytouch-PMS.svg";
import ThirdPartySWIssues from "../../assets/icons/third-party-software.svg";
import VirtualAgentTrainingIssues from "../../assets/icons/virtual-agent-training-issue.svg";
import VisualMatricPMSIssues from "../../assets/icons/visual-matrix-PMS.svg";
import OSIssues from "../../assets/icons/windows-OS.svg";
import android_user from "../../assets/icons/android.svg";
import avg_call_duration from "../../assets/icons/avg-call-duration.svg";
import transaction_duration from "../../assets/icons/avg-transaction-duration.svg";
import call_log from "../../assets/icons/call-log.svg";
import call from "../../assets/icons/call.png";
import cash_collected_transaction from "../../assets/icons/cash-collected-transaction.svg";
import cash_collected from "../../assets/icons/cash-collected.svg";
import cash_dispensed_transaction from "../../assets/icons/cash-dispensed-transaction.svg";
import cash from "../../assets/icons/cash.svg";
import checkin from "../../assets/icons/checkin.svg";
import checkout from "../../assets/icons/checkout.svg";
import daily_calls from "../../assets/icons/daily-calls.svg";
import dinning_orders from "../../assets/icons/dining.svg";
import dislike from "../../assets/icons/dislike.svg";
import SelfCheckInIcon from "../../assets/icons/SelfCheckInIcon.svg";
import guest_users from "../../assets/icons/guest-session.svg";
import housekeeping_orders from "../../assets/icons/Housekeeping-orders.svg";
import housekeeping_tickets from "../../assets/icons/Housekeeping-tickets.svg";
import IoS_users from "../../assets/icons/ios.svg";
import keys from "../../assets/icons/keys.svg";
import like from "../../assets/icons/like.svg";
import hotels from "../../assets/icons/live-hotel.svg";
import maintenance_tickets from "../../assets/icons/maintenance.svg";
import reservations from "../../assets/icons/reservation.svg";
import reviews from "../../assets/icons/review.svg";
import scan_details from "../../assets/icons/scan-details.svg";
import staff_users from "../../assets/icons/staff-session.svg";
import support_ticket from "../../assets/icons/support-ticket.svg";
import transaction from "../../assets/icons/transaction.svg";
import walkin from "../../assets/icons/walkin.svg";
import CallAcceptedIcon from "../../assets/icons/call-accepted.svg";
import CallMissedIcon from "../../assets/icons/calls-missed.svg";
import AvgResTimeIcon from "../../assets/icons/average-response-time.svg";
import ShiftNotesIcon from "../../assets/icons/shift-notes.svg";
import ReceiptSentIcon from "../../assets/icons/receipts-sent.svg";
import EnrollCountIcon from "../../assets/icons/enrolled-count.svg";
import MissedCallsRate from "../../assets/icons/missed-call-rate.svg";


export const dashboardUrlList = [
    {
        queryKey: "kioskCount",
        url: "getDashboardKioskCounts",
    },
    {
        queryKey: "cashCount",
        url: "getDashboardCashCounts",
    },
    {
        queryKey: "hotelCount",
        url: "getDashboardHotelCounts",
    },
    {
        queryKey: "dynaTraceCount",
        url: "getDashboardDynaCounts",
    },
    {
        queryKey: "callCount",
        url: "getDashboardCallCounts",
    },
    {
        queryKey: "newCallCount",
        url: "getDashboardNewCallCounts",
    },
    {
        queryKey: "reviewsCount",
        url: "getDashboardReviewsCounts",
    },
    {
        queryKey: "commonCount",
        url: "getDashboardCommonCounts",
    },
    {
        queryKey: "shiftNotesCounts",
        url: "getDashboardShiftNotesCounts",
    },
    {
        queryKey: "missedCallRateCounts",
        url: "getDashboardMissedcallsRateCounts",
    }
];

export const DashboardGrids = [
    {
        title: "CheckIns",
        key: "total_checkin_new",
        Icon: checkin,
        info: "Total Reservations and Walkins",
    },
    {
        title: "Reservations",
        key: "checkin_count",
        Icon: reservations,
        info: "Total Reservations",
    },
    {
        title: "WalkIns",
        key: "walkin_count",
        Icon: walkin,
        info: "Total WalkIns",
    },
    {
        title: "WalkIns Logs",
        key: "walkin_logs_count",
        Icon: walkin,
        info: "Records Of WalkIns",
    },
    {
        title: "IDs Scanned",
        key: "scan_count",
        Icon: id_scan,
        info: "Total Ids Scanned",
    },
    {
        title: "Keys",
        key: "keys_count",
        Icon: keys,
        info: "Total Keys Dispensed",
    },
    {
        title: "Cash Collected",
        key: "cash_collected",
        Icon: cash_collected,
        info: "Total Cash Collected",
    },
    {
        title: "Cash",
        key: "total_cash",
        Icon: cash,
        info: "Total Cash Collected & Cash Dispensed",
    },
    {
        title: "Cash Collected Transactions",
        key: "cash_collected_trans",
        Icon: cash_collected_transaction,
        info: "Total Cash Collected/Transaction",
    },
    {
        title: "Cash Dispensed",
        key: "cash_dispence",
        Icon: cash_dispensed,
        info: "Total Cash Dispensed",
    },
    {
        title: "Cash Dispensed Transactions",
        key: "cash_dispenced_trans",
        Icon: cash_dispensed_transaction,
        info: "Total Cash Dispensed/Transaction",
    },
    {
        title: "Daily Co calls",
        key: "calls_count",
        Icon: daily_calls,
        info: "Total Video Calls Using DailyCo",
    },
    {
        title: "11Sight Calls",
        key: "new_calls_count",
        Icon: call,
        info: "Total Video Calls using 11Sight",
    },
    {
        title: "Call Logs",
        key: "call_logs_count",
        Icon: call_log,
        info: "Call Details Of Phone Calls By Front Desk Agents",
    },
    {
        title: "Transactions",
        key: "transaction_count",
        Icon: transaction,
        info: "Total Transactions",
    },
    {
        title: "Housekeeping Tickets",
        key: "hk_ticket_count",
        Icon: housekeeping_tickets,
        info: "Total HouseKeeping Tickets",
    },
    {
        title: "Housekeeping Orders",
        key: "hk_order_count",
        Icon: housekeeping_orders,
        info: "Total HouseKeeping Orders",
    },
    {
        title: "Maintenance Tickets",
        key: "mnt_ticket_count",
        Icon: maintenance_tickets,
        info: "Total Maintenance Tickets",
    },
    {
        title: "Dining Orders",
        key: "dinning_order_count",
        Icon: dinning_orders,
        info: "Total Dining Orders",
    },
    {
        title: "Staff Sessions",
        key: "staff_user_count",
        Icon: staff_users,
        info: "Period Of Time In Which Users Has Interacted With The Staff App",
    },
    {
        title: "Guest Sessions",
        key: "guest_user_count",
        Icon: guest_users,
        info: "Period Of Time In Which Users Has Interacted With The Guest App",
    },
    {
        title: "IoS Sessions",
        key: "ios_user_count",
        Icon: IoS_users,
        info: "Period Of Time In Which Users Has Interacted With The IoS App",
    },
    {
        title: "Android Sessions",
        key: "android_user_count",
        Icon: android_user,
        info: "Period Of Time In Which Users Has Interacted With The Android App",
    },
    {
        title: "Reviews",
        key: "reviews",
        Icon: reviews,
        info: "Total Reviews By Customers",
    },
    {
        title: "Average Transaction Duration",
        key: "transaction_avg",
        Icon: transaction_duration,
        info: "Average Transaction Duration",
    },
    {
        title: "Average Call Duration",
        key: "avg_total_time",
        Icon: avg_call_duration,
        info: "Average Time Of Video Calls",
    },
    {
        title: "Live Hotel",
        key: "hotel_total",
        Icon: hotels,
        info: "Total Live Hotals In Production",
    },
    // {
    //     title: "Upcoming Hotel",
    //     key: "upcoming_total",
    //     Icon: upcoming_hotels,
    //     info: "Hotels In Pipeline",
    // },
    {
        title: "Scan Details",
        key: "no_scan_count",
        Icon: scan_details,
        info: "Records Of Scan Details",
    },
    {
        title: "Support Tickets",
        key: "spticket_count",
        Icon: support_ticket,
        info: "Total Issues Related To Support",
    },
    // {
    //     title: "HubSpot Tickets",
    //     key: "hubspot_tickets_count",
    //     Icon: Hubspot,
    //     info: "Total HubSpot Tickets",
    // },
    {
        title: "CheckOuts",
        key: "checkout_keys_count",
        Icon: checkout,
        info: "Total CheckOuts",
    },
    {
        title: "Likes",
        key: "like_count",
        Icon: like,
        info: "Total Likes By Customers",
    },
    {
        title: "Dislikes",
        key: "dislike_count",
        Icon: dislike,
        info: "Total Dislikes By Customers",
    },
    {
        title: "Enrolled Count",
        key: "enrolled_count",
        Icon: EnrollCountIcon,
        info: "Total Enrolled Users",
    },
    {
        title: "Calls Accepted",
        key: "accepted_calls_counts",
        Icon: CallAcceptedIcon,
        info: "Total Calls Accepted",
    },
    {
        title: "Calls Missed",
        key: "missed_calls_counts",
        Icon: CallMissedIcon,
        info: "Total Calls Missed",
    },
    {
        title: "Average Response Time",
        key: "avg_response_total_time",
        Icon: AvgResTimeIcon,
        info: "Total Average Response Time",
    },
    {
        title: "Self Check-Ins",
        key: "self_checkin_count",
        Icon: SelfCheckInIcon,
        info: "Total Self Check-Ins",
    },
    {
        title: "Shift Notes",
        key: "shift_notes_count",
        Icon: ShiftNotesIcon,
        info: "Total Shift Notes",
    },
    {
        title: "Receipts Sent",
        key: "receipts_sent_counts",
        Icon: ReceiptSentIcon,
        info: "Total Receipt Sent",
    },
    {
        title: "Pbx calls",
        key: "pbx_calls",
        Icon: ReceiptSentIcon,
        info: "Total Pbx Calls",
    },
    {
        title: "Missed Call Rate",
        key: "missed_call_rate",
        Icon: MissedCallsRate,
        info: "The ratio of missed calls (PBX and Kiosk) to the total number of calls, including both",
    }
];


export const qualityMatricsGrids = [
    {
        title: "Audio",
        key: "audio_count",
        Icon: audio,
        info: "Audio Issue to Total Valid transaction Ratio",
        componentName: "Audio",
    },
    {
        title: "Card Dispenser",
        key: "card_dispenser_count",
        Icon: card_dispenser,
        info: "Card dispenser Issue to Total Valid transaction Ratio",
        componentName: "Key Dispenser",
    },
    {
        title: "Card Encoder",
        key: "card_encoder_count",
        Icon: card_encoder,
        info: "Card Encoder Issue to Total Valid transaction Ratio",
        componentName: "Key Encoder",
    },
    {
        title: "Cash Dispenser",
        key: "cash_dispenser_count",
        Icon: cash_dispenser,
        info: "Cash dispenser Issue to Total Valid transaction Ratio",
        componentName: "Cash Dispenser",
    },
    {
        title: "Cash Acceptor",
        key: "cash_acceptor_count",
        Icon: cash_acceptor,
        info: "Cash Acceptor Issue to Total Valid transaction Ratio",
        componentName: "Cash Acceptor",
    },
    {
        title: "Credit Card",
        key: "credit_card_count",
        Icon: credit_card,
        info: "Credit Card Issue to Total Valid transaction Ratio",
        componentName: "Credit Card Machine",
    },
    {
        title: "ID Scanner",
        key: "id_scanner_count",
        Icon: id_scanner,
        info: "ID Scanner Issue to Total Valid transaction Ratio",
        componentName: "ID Scanner",
    },
    {
        title: "PMS Application",
        key: "pms_application_count",
        Icon: pms_application,
        info: "PMS Application Issue to Total Valid transaction Ratio",
        componentName: "PMS Application",
    },
    {
        title: "Aavgo Portal",
        key: "portal_count",
        Icon: aavgo_portal,
        info: "Aavgo Portal Issue to Total Valid transaction Ratio",
        componentName: "Aavgo Portal",
    },
    {
        title: "Power Outage",
        key: "power_outage_count",
        Icon: power_outage,
        info: "Power Outage Issue to Total Valid transaction Ratio",
        componentName: "Power Outage",
    },
    {
        title: "Property Network Issues",
        key: "property_network_issue_count",
        Icon: property_network_issues,
        info: "Property Network Issue to Total Valid transaction Ratio",
        componentName: "Network",
    },
    {
        title: "Receipt Printer",
        key: "receipt_printer_count",
        Icon: receipt_printer,
        info: "Receipt printer Issue to Total Valid transaction Ratio",
        componentName: "Receipt Printer",
    },
    {
        title: "Registration Card",
        key: "reg_card_count",
        Icon: registration_card,
        info: "Registration Card Issue to Total Valid transaction Ratio",
        componentName: "Registration Card",
    },
    {
        title: "SplashTop",
        key: "splashtop_count",
        Icon: splashtop,
        info: "Splashtop Issue to Total Valid transaction Ratio",
        componentName: "Splashtop",
    },
    {
        title: "Video Call",
        key: "video_call_count",
        Icon: video_call,
        info: "Video Call Issue to Total Valid transaction Ratio",
        componentName: "Video Call",
    },
    {
        title: "Agent Network Issues",
        key: "agent_network_issue_count",
        Icon: agent_network_issue,
        info: "Agent Network Issue to Total Valid transaction Ratio",
        componentName: "Agent Network issue",
    },
    {
        title: "Others",
        key: "other_count",
        Icon: other,
        info: "Other Issue to Total Valid transaction Ratio",
        componentName: "Other",
    },

    {
        title: "Camera",
        key: "camera_count",
        Icon: CameraIssues,
        info: "Camera Issue to Total Valid transaction Ratio",
        componentName: "Camera",
    },

    {
        title: "False Positive",
        key: "false_positive_count",
        Icon: FalsePositiveIssues,
        info: "False Positive Issue to Total Valid transaction Ratio",
        componentName: "False Positive",
    },
    {
        title: "Kiosk App",
        key: "kiosk_app_count",
        Icon: KioskAppIssues,
        info: "Kiosk App Issue to Total Valid transaction Ratio",
        componentName: "Kiosk App",
    },
    {
        title: "Kiosk Machine",
        key: "kiosk_machine_count",
        Icon: KioskMachineIssues,
        info: "Kiosk Machine Issue to Total Valid transaction Ratio",
        componentName: "Kiosk Machine",
    },
    {
        title: "PBX",
        key: "pbx_count",
        Icon: PBXIssues,
        info: "PBX Issue to Total Valid transaction Ratio",
        componentName: "PBX",
    },
    {
        title: "Network",
        key: "network_count",
        Icon: NetWorkIssues,
        info: "Network Issue to Total Valid transaction Ratio",
        componentName: "Network",
    },
    {
        title: "Third party software",
        key: "third_party_software_count",
        Icon: ThirdPartySWIssues,
        info: "Third party software Issue to Total Valid transaction Ratio",
        componentName: "Third party software",
    },
    {
        title: "Virtual Agent Training Issue",
        key: "virtual_agent_training_issue_count",
        Icon: VirtualAgentTrainingIssues,
        info: "Virtual Agent Training Issue to Total Valid transaction Ratio",
        componentName: "Virtual Agent Training Issue",
    },
    {
        title: "Windows OS",
        key: "windows_os_count",
        Icon: OSIssues,
        info: "Windows OS Issue to Total Valid transaction Ratio",
        componentName: "Windows OS",
    },
    {
        title: "Choice advantage PMS",
        key: "choice_advantage_pms_count",
        Icon: ChoiceAdvantageIssues,
        info: "Choice advantage PMS Issue to Total Valid transaction Ratio",
        componentName: "Choice advantage PMS",
        parent: "PMS Softwares",
    },
    {
        title: "Jonas Chorum PMS Software",
        key: "jonas_chorum_pms_software_count",
        Icon: JCSoftwareIssues,
        info: "Jonas Chorum PMS Software Issue to Total Valid transaction Ratio",
        componentName: "Jonas Chorum PMS Software",
        parent: "PMS Softwares",
    },
    {
        title: "Skytouch PMS",
        key: "skytouch_pms_count",
        Icon: SkyTouchIssues,
        info: "Skytouch PMS Issue to Total Valid transaction Ratio",
        componentName: "Skytouch PMS",
        parent: "PMS Softwares",
    },
    {
        title: "Visual Matrix PMS",
        key: "visual_matrix_pms_count",
        Icon: VisualMatricPMSIssues,
        info: "Visual Matrix PMS Issue to Total Valid transaction Ratio",
        componentName: "Visual Matrix PMS",
        parent: "PMS Softwares",
    },
    {
        title: "Other PMS",
        key: "other_pms_count",
        Icon: OtherPMSIssues,
        info: "Other PMS Issue to Total Valid transaction Ratio",
        componentName: "Other PMS",
        parent: "PMS Softwares",
    },
    {
        title: "Acculock key software",
        key: "acculock_key_software_count",
        Icon: AcculockIssues,
        info: "Acculock key software Issue to Total Valid transaction Ratio",
        componentName: "Acculock key software",
        parent: "Key Softwares",
    },
    {
        title: "Assaabloy key software",
        key: "assaabloy_key_software_count",
        Icon: AssaAbloyIssues,
        info: "Assaabloy key software Issue to Total Valid transaction Ratio",
        componentName: "Assaabloy key software",
        parent: "Key Softwares",
    },
    {
        title: "Beeline key software",
        key: "beeline_key_software_count",
        Icon: BeelineIssues,
        info: "Beeline key software Issue to Total Valid transaction Ratio",
        componentName: "beeline key software",
        parent: "Key Softwares",
    },
    {
        title: "Innguru key software",
        key: "innguru_key_software_count",
        Icon: InnGuruIssues,
        info: "Innguru key software Issue to Total Valid transaction Ratio",
        componentName: "Innguru key software",
        parent: "Key Softwares",
    },
    {
        title: "Miwa Key Software",
        key: "miwa_Key_software_count",
        Icon: MiwaIssues,
        info: "Miwa Key Software Issue to Total Valid transaction Ratio",
        componentName: "Miwa Key Software",
        parent: "Key Softwares",
    },
    {
        title: "Safelock key software",
        key: "safelock_key_software_count",
        Icon: SafeLockIssues,
        info: "Safelock key software Issue to Total Valid transaction Ratio",
        componentName: "Safelock key software",
        parent: "Key Softwares",
    },
    {
        title: "Saflok Key Software",
        key: "saflok_key_software_count",
        Icon: SafLockIssues,
        info: "Saflok Key Software Issue to Total Valid transaction Ratio",
        componentName: "Saflok Key Software",
        parent: "Key Softwares",
    },
];

export const qualityMetricsUrlList = [
    {
        queryKey: "qualityMetrix",
        url: "getSupportTicketErrorCounts",
    },
    {
        queryKey: "qualityMetrixNew",
        url: "getMoreSupportTicketErrorCounts",
    },
];